import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { Reveal } from "./Reveal";

const ScrollMedia = ({ children, flip }) => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 0.5, 1], [70, 0, -50]);
  const scale = useTransform(scrollYProgress, [0, 0.45], [0.92, 1]);
  const rotate = useTransform(scrollYProgress, [0, 0.45], [flip ? -2.5 : 2.5, 0]);
  return (
    <div ref={ref}>
      <motion.div style={{ y, scale, rotate }}>{children}</motion.div>
    </div>
  );
};

export const ToolSection = ({ id, eyebrow, title, accent, text, cta, onCta, flip = false, media, extra }) => (
  <section id={id} data-testid={`${id}-section`} className="relative py-20 lg:py-32">
    <div className="max-w-[1440px] mx-auto px-5 sm:px-8 grid lg:grid-cols-12 gap-10 lg:gap-16 items-center">
      <div className={`lg:col-span-7 ${flip ? "lg:order-2" : ""}`}><ScrollMedia flip={flip}>{media}</ScrollMedia></div>
      <Reveal className={`lg:col-span-5 ${flip ? "lg:order-1" : ""}`}>
        <div className="eyebrow mb-5 flex items-center gap-3"><span className="h-px w-8 bg-gradient-to-r from-white/70 to-transparent" />{eyebrow}</div>
        <h2 className="h-display chrome text-3xl sm:text-4xl lg:text-5xl">
          {title}
          <br />
          <span className="text-outline-silver">{accent}</span>
        </h2>
        <p className="mt-6 text-slate-300 text-base md:text-lg leading-relaxed max-w-md">{text}</p>
        {extra}
        <button data-testid={`${id}-cta`} onClick={onCta} className="btn-solid px-6 py-4 mt-8">
          {cta} <ArrowRight className="h-4 w-4" />
        </button>
      </Reveal>
    </div>
  </section>
);
